import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppWeightUpdateGoalPage } from './app-weight-update-goal';
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
  declarations: [
    AppWeightUpdateGoalPage,
  ],
  imports: [
    IonicPageModule.forChild(AppWeightUpdateGoalPage),
    PipesModule,
  ],
})
export class AppWeightUpdateGoalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-weight-update-goal/app-weight-update-goal.module.ts